import type { LogisticsIntegrationView, ShipmentStatus } from "@cx/contracts";
import { LOGISTICS_PROVIDER_LABELS, shipmentStatusLabel, type LogisticsProvider } from "@cx/domain";
import type { Tone } from "@cx/ui";

// ===== Rótulos da logística (T3.4) =====

export const SHIPMENT_STATUS_TONE: Record<ShipmentStatus, Tone> = {
  pending: "secondary",
  label_ready: "info",
  posted: "info",
  in_transit: "info",
  out_for_delivery: "warning",
  delivered: "success",
  failed: "warning",
  returned: "danger",
  expired: "secondary",
  error: "danger",
  canceling: "secondary",
  canceled: "secondary",
};

export const statusLabel = (s: ShipmentStatus, reverse = false) => shipmentStatusLabel(s, reverse);
export const providerLabel = (p: LogisticsProvider) => LOGISTICS_PROVIDER_LABELS[p];

export const INTEGRATION_STATUS_LABEL: Record<LogisticsIntegrationView["status"], string> = {
  active: "Ativa",
  reauth_required: "Reconectar",
  inactive: "Desativada",
};
export const INTEGRATION_STATUS_TONE: Record<LogisticsIntegrationView["status"], Tone> = {
  active: "success",
  reauth_required: "warning",
  inactive: "secondary",
};

/** Peso em gramas → "1,250 kg" (inteiro, sem float). */
export const kgLabel = (g: number) => `${Math.trunc(g / 1000)},${String(g % 1000).padStart(3, "0")} kg`;
/** "20 × 15 × 10 cm" (comprimento × largura × altura). */
export const dimsLabel = (p: { lengthCm: number; widthCm: number; heightCm: number }) =>
  `${p.lengthCm} × ${p.widthCm} × ${p.heightCm} cm`;
/** Peso digitado em kg (vírgula ou ponto, até 3 casas) → gramas; inválido = null. */
export function kgToGrams(text: string): number | null {
  const m = /^\s*(\d{1,3})(?:[.,](\d{1,3}))?\s*$/.exec(text);
  if (!m) return null;
  const g = Number(m[1]) * 1000 + Number((m[2] ?? "").padEnd(3, "0"));
  return g > 0 ? g : null;
}
export const gramsToKgInput = (g: number) => kgLabel(g).replace(" kg", "");
export const cepLabel = (cep: string) => (/^\d{8}$/.test(cep) ? `${cep.slice(0, 5)}-${cep.slice(5)}` : cep);
/** "1 dia útil", "3 dias úteis". */
export const daysLabel = (d: number | null) =>
  d === null ? "—" : `${d} ${d === 1 ? "dia útil" : "dias úteis"}`;

/** Link de rastreio público (Correios: código S10). */
export const trackingUrl = (code: string | null) =>
  code && /^[A-Z]{2}\d{9}[A-Z]{2}$/.test(code)
    ? `https://rastreamento.correios.com.br/app/index.php?objeto=${code}`
    : null;

export const BATCH_STATUS_LABEL: Record<"open" | "closed", string> = { open: "Aberta", closed: "Fechada" };
export const BATCH_STATUS_TONE: Record<"open" | "closed", Tone> = { open: "warning", closed: "success" };
export const BATCH_LABELS_LABEL: Record<"none" | "pending" | "ready" | "error", string> = {
  none: "—",
  pending: "Gerando etiquetas…",
  ready: "Etiquetas prontas",
  error: "Falha nas etiquetas",
};
